export const DEFAULT_MAP_STYLE = "road";
export const DEFAULT_PLANS_VIEW = "table";

export const MAP_STYLE_OPTIONS = Object.freeze([
  { value: "road", label: "Carretera", icon: "fa fa-road" },
  { value: "grayscale_light", label: "Claro", icon: "fa fa-sun" },
  { value: "grayscale_dark", label: "Oscuro", icon: "fa fa-circle-half-stroke" },
  { value: "satellite", label: "Satélite", icon: "fa fa-satellite" },
  { value: "night", label: "Noche", icon: "fa fa-moon" },
]);

export function isValidMapStyle(style) {
  return MAP_STYLE_OPTIONS.some((option) => option.value === style);
}

export function resolveMapStyle(style) {
  return isValidMapStyle(style) ? style : DEFAULT_MAP_STYLE;
}

export function getAccountMapStyle(account) {
  return resolveMapStyle(account?.preferences?.maps?.default_style);
}

export function getAccountPlansView(account) {
  const value = String(account?.preferences?.plans?.default_view || "").trim();
  return value === "calendar" ? "calendar" : DEFAULT_PLANS_VIEW;
}
